<template>
	<v-sheet elevation="0">
		<!-- <FunctionTitle :title="mainTitle" /> -->
		<CommonFlame :title="pageTitle" class="mt-2">
			<template v-if="!$vuetify.breakpoint.xs" v-slot:app-bar-btn>
				<v-btn v-if="authority" color="primary" class="ml-2" @click.stop="redirectToEditPage">
					<v-icon class="mr-1">mdi-plus</v-icon>
					案件編集
				</v-btn>
			</template>
			<template v-if="$vuetify.breakpoint.xs">
				<v-btn v-if="authority" color="secondary" class="ml-2" @click.stop="redirectToEditPage">
					<v-icon>mdi-plus</v-icon>
					案件編集
				</v-btn>
			</template>
			<MatterInfo :matter="matter" :current_company_name="current_company_name" />
			<v-row no-gutters class="my-4 pb-4" justify="start">
				<v-btn dark outlined @click="MatterFileIndexDialogFlag = true" color="secondary">
					<v-icon>mdi-paperclip</v-icon> 案件添付ファイル一覧
				</v-btn>
			</v-row>
			<MatterFileIndexDialog
				v-if="MatterFileIndexDialogFlag"
				@close="MatterFileIndexDialogFlag = false"
				:id="this.matter.id"
			/>
		</CommonFlame>
	</v-sheet>
</template>

<script>
import axios from "axios"

import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import FunctionTitle from "../shared/FunctionTitle.vue"
import CommonFlame from "../shared/CommonFlame.vue"
import MatterInfo from "../shared/MatterInfo.vue"
import MatterFileIndexDialog from "../shared/MatterFileIndexDialog.vue"

export default {
	components: {
		FunctionTitle,
		CommonFlame,
		MatterInfo,
		MatterFileIndexDialog,
	},
	data() {
		return {
			mainTitle: "案件詳細ページ",
			pageTitle: "案件詳細情報",
			MatterFileIndexDialogFlag: false,
			id: this.$route.params.id,
			current_company_name: null,
			authority: false,
			matter: {
				created_at: null,
				updated_at: null,
				name: null,
				quotation_number: null,
				quotation_sub_number: null,
				contract: null,
				product_category: {
					name: null,
				},
				product_sub_category: {
					name: null,
				},
				team: {
					name: null,
				},
				team_member_name: null,
				regularly_sold: null,
				description: null,
				points: null,
				ordered_products: [{ order_individual_infos: {}, delivery_info: {} }],
			},
		}
	},
	mounted() {
		this.fetchMatter()
	},
	methods: {
		redirectToEditPage() {
			this.$router.push({ name: "matter_edit", params: { id: this.id } })
		},
		fetchMatter() {
			const headers = authenticate.setHeader()

			axios
				.get(`/erp/v1/matters/${this.id}`, { headers })
				.then((res) => {
					this.matter = res.data.matter
					this.current_company_name = res.data.current_company_name
					this.authority = res.data.authority
					console.log(this.matter)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
}
</script>
